import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// Configuración de Firebase para Forax Web
const firebaseConfig = {
  apiKey: 'AIzaSyCGv0HkKWF-pK4aVPyqXGenGtmGuUSjYXg',
  authDomain: 'forax-web.firebaseapp.com',
  projectId: 'forax-web',
  storageBucket: 'forax-web.firebasestorage.app',
  messagingSenderId: '758423921596',
  appId: '1:758423921596:web:7291abda42e34b686641b9',
}

// Inicializar Firebase
const app = initializeApp(firebaseConfig)

// Inicializar servicios
export const db = getFirestore(app)
export const storage = getStorage(app)
